import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from '../PopupBox.js';

import Form from 'react-bootstrap/Form';

import Countdown from '../Countdown.js';



export default class TrickyBox extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
        ticks: [false, true, true, true, false, true, false]
    };
  }



  render() {



    //handle the click on one of the buttons
    const handleSelect = (e) => {

        e.preventDefault()

        console.log("select", e)


        var newTicks = this.state.ticks;

        for(var i = 0; i < this.state.ticks.length; i ++)
        {
            if( parseInt(e.target.getAttribute("num")) != i)
            {
                newTicks[i] = !newTicks[i]
            }
        }

        this.setState({ticks: newTicks})


        console.log("this.state.ticks: ", this.state.ticks)


        //check if all ticks are off


    };


      //handle the click on one of the buttons
      const handleClick = (e) => {

        var num_ticks = 0

        for(var i = 0; i < this.state.ticks.length; i ++)
        {
            if(this.state.ticks[i])
            {
                num_ticks ++
            }
        }

        console.log("num_ticks: ", num_ticks);

        console.log("this.state.ticks: ", this.state.ticks);

        

        if(num_ticks == 0)
        {
            this.props.setResult(true, this)
        }
        else
        {
          this.props.setResult(false, this)
        }

    };





    let position = "_"

    position = this.props.getPos(this)

    console.log(position)
    
    

    var boxes = []

    var num_boxes = 7

    for(var i = 0; i < num_boxes; i ++)
    {
        boxes.push( <Form.Check onChange={handleSelect} checked={this.state.ticks[i]} num={i} className="checkbox" aria-label={"option_"+i}/>)
    }

    return (




      <PopupBox position={this.props.position} getPos={this.props.getPos} question={this}>


      
      <Countdown time_allowed={60} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>

     
     
        <h2 className="text-danger">{this.props.question}</h2>

        
        <br></br>

        {boxes}

        <br></br>

        <Button value="0" onMouseDown={handleClick} className="m-1" variant={this.props.color0} size="lg">Submit</Button>  
                
      </PopupBox>

    );
  }
}
